import { record } from '../utils/recorder';
import {
    AddSubChartMutation,
    RemoveSubChartMutation,
    SetChartSpacePropertiesMutation,
    SetSubChartMutation,
} from '../mutation/shape/chart';
import { SubChart } from '../mutation/shape/chart/sub-chart';
import { GraphicFrameBaseMutationAPI } from './graphic-frame-base-mutation-api';
import type { ChartDataModel } from '../model/chart-data-model';
import type { IChartData, ISubChartData } from '../data';
import type { DeltaOf } from '../utils/delta';

export class ChartMutationAPI extends GraphicFrameBaseMutationAPI<IChartData, ChartDataModel> {
    /**
     * 更新 GraphicalObjectFrame 属性
     */
    @record()
    public updateProps({ spPr, nvPr, graphic, bwMode, chartSpace }: DeltaOf<IChartData>) {
        return this.transaction(() => {
            // 更新通用的graphicFrame相关属性
            super.updateProps({ spPr, nvPr, graphic, bwMode });

            // 变更包含图表内容时，更新chartSpace相关属性
            if (chartSpace) {
                this.request([
                    new SetChartSpacePropertiesMutation({
                        pageId: this.model.getPage().id,
                        shapeId: this.model.id,
                        chartSpacePr: chartSpace,
                    }),
                ]);
            }
        });
    }

    /**
     * 更新子表属性
     */
    @record()
    public updateSubChartProps(subChart: ISubChartData, index: number) {
        return this.transaction(() => {
            this.request([
                new SetSubChartMutation({
                    pageId: this.model.getPage().id,
                    shapeId: this.model.id,
                    index,
                    /** 包含各种类型的子表的属性 */
                    plot: new SubChart().createEgPlotBySubChart(subChart),
                    axesPr: {
                        axes: subChart.axes,
                        index: subChart.axesAddIndex,
                    },
                }),
            ]);
        });
    }

    /**
     * 添加子表
     */
    @record()
    public addSubChart(subChart: ISubChartData, index: number) {
        return this.transaction(() => {
            this.request([
                new AddSubChartMutation({
                    pageId: this.model.getPage().id,
                    shapeId: this.model.id,
                    index,
                    subChartType: subChart.type,
                }),
                new SetSubChartMutation({
                    pageId: this.model.getPage().id,
                    shapeId: this.model.id,
                    index,
                    /** 包含各种类型的子表的属性 */
                    plot: new SubChart().createEgPlotBySubChart(subChart),
                    axesPr: {
                        axes: subChart.axes,
                        index: subChart.axesAddIndex,
                    },
                }),
            ]);
        });
    }

    /**
     * 移除子表
     */
    @record()
    public removeSubChart(index?: number) {
        return this.transaction(() => {
            this.request([
                new RemoveSubChartMutation({
                    pageId: this.model.getPage().id,
                    shapeId: this.model.id,
                    index: index ?? 0,
                }),
            ]);
        });
    }
}
